import React from 'react';
import { TechnicianCityGroup } from './TechnicianCityGroup';

/**
 * Listagem por cidade (título no header da seção FUTURA).
 */
export function FuturaRetornoTechnicianOrdersPanel({
  groupedRetornoByCity,
  technician,
  groupName,
  isDroppable,
  setIsDraggingOrder,
  onBoardOrderDragStart,
  onBoardOrderDragEnd,
  showDefeitoColumn,
  codstatusRetornoEmAberto,
  codstatusPedidoVinculadoDisponivel,
  extraRetornoStatusesEmAberto,
  selectedOrders,
  setContextMenu,
  handleOrderClick,
  userShowOSConfig,
  setSelectedOrders,
  defeitosData,
  loadingDefeitos
}) {
  return (
    <div className="service-orders-container">
      {groupedRetornoByCity && Object.keys(groupedRetornoByCity).length > 0 ? (
        <div className="technician-forecast-group">
          <div className="forecast-orders-container">
            {Object.entries(groupedRetornoByCity).map(([cidade, ordens]) => (
              <TechnicianCityGroup
                key={cidade}
                cidade={cidade}
                ordens={ordens}
                technician={technician}
                groupName={groupName}
                isDroppable={isDroppable}
                setIsDraggingOrder={setIsDraggingOrder}
                onBoardOrderDragStart={onBoardOrderDragStart}
                onBoardOrderDragEnd={onBoardOrderDragEnd}
                showDefeitoColumn={showDefeitoColumn}
                codstatusRetorno={codstatusRetornoEmAberto}
                codstatusPedidoVinculadoDisponivel={codstatusPedidoVinculadoDisponivel}
                extraRetornoStatuses={extraRetornoStatusesEmAberto}
                selectedOrders={selectedOrders}
                setContextMenu={setContextMenu}
                handleOrderClick={handleOrderClick}
                userShowOSConfig={userShowOSConfig}
                setSelectedOrders={setSelectedOrders}
                defeitosData={defeitosData}
                loadingDefeitos={loadingDefeitos}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="empty-service-group">Nenhuma OS nesta visão</div>
      )}
    </div>
  );
}
